export const CHECKOUT_URL = 'https://usaebookpoint.shop/cart/54966664429940:1'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/tLaZGoxEXCdoWYXd5w5eAk/ChatGPT_Image_Jul_15,_2026,_01_51_35_PM.png'

export const COURT_BG =
  'https://cdn.magicpatterns.com/patterns/generated-images/e0512e93-39b6-4647-bd88-00a517a830c3.jpg'

export interface Module {
  emoji: string
  title: string
  items: string[]
}

export const MODULES: Module[] = [
  {
    emoji: '🎯',
    title: 'VOLUME 1 — Technique and Fundamentals of the Game',
    items: [
      'Anatomy of the Shot: Grip, Paddle Face, and Contact',
      'Dinking: The Foundation of the Game',
      'Serve and Return: Variations and Teaching Progressions',
      'Volleys and Kitchen Line Play',
      'Drives, Lobs, and Drop Shots: When to Teach Each One',
      'The Third Shot Drop: The Technique That Separates Skill Levels',
      'Common Technical Errors by Level (2.5 to 4.0) and How to Fix Them',
    ],
  },
  {
    emoji: '📋',
    title: 'VOLUME 2 — Pre-Built Classes by Level',
    items: [
      'Standard Class Structure',
      '12 Complete Classes for Beginners (2.0–2.5)',
      '12 Complete Classes for Intermediate Players (3.0–3.5)',
      '12 Complete Classes for Advanced Players (4.0+)',
      'Group vs. Individual Classes: Adapting the Same Lesson',
      'Themed Clinics',
    ],
  },
  {
    emoji: '🧠',
    title: 'VOLUME 3 — Strategy and Game Criteria',
    items: [
      'Positioning Criteria: Singles vs. Doubles',
      'When to Move Up to the Net and When to Hold Back',
      'Reading the Opponent: Patterns and Real-Time Decision-Making',
      'Doubles Strategy: Communication, Stacking, and Switching',
      'Shot Selection Criteria Based on Game Situation',
      'Strategic Errors by Level and How to Teach Players to Recognize Them',
    ],
  },
  {
    emoji: '💪',
    title: 'VOLUME 4 — Physical Preparation and Injury Prevention',
    items: [
      'The Specific Physical Demands of Pickleball',
      'Mobility and Activation Before Class',
      'Functional Strength: Lower Body, Core, and Shoulder',
      'Preventing Common Injuries',
      'Routines for 50+ Students (a Major Share of the U.S. Market)',
      'Recovery and Post-Class/Tournament Work',
    ],
  },
  {
    emoji: '📅',
    title: 'VOLUME 5 — Periodization and Planning',
    items: [
      'The Annual Macrocycle for Recreational vs. Competitive Players',
      'Mesocycles: Structuring 4–6 Weeks of Real Progress',
      'Sample Weekly Microcycle by Student Goal',
      'Tournament Periodization (Peaking)',
      'Adjusting Load by Age and Physical Level',
      'Progress-Tracking Templates (Technical + Physical)',
    ],
  },
  {
    emoji: '💬',
    title: 'VOLUME 6 — Communication and Coaching',
    items: [
      'Giving Technical Feedback Without Frustrating the Adult Student',
      'Communicating with 50+ Students vs. Younger/Competitive Students',
      'Managing Mixed-Level Groups',
      'Motivation and Retention: Why Students Stop Coming Back',
      'Communicating with Parents (for Junior Students)',
      'Scripts for the First Lesson and Level Assessment',
    ],
  },
  {
    emoji: '💰',
    title: 'VOLUME 7 — Running the Business: Billing and Growth',
    items: [
      'Pricing Models (Per Class, Package, Membership)',
      'Recurring Billing Systems and Cancellation Policies',
      'Building Packages That Drive Retention',
      'Referrals and Word of Mouth: A System, Not Luck',
      'Getting Into Clubs and Courts',
      'Legal Basics: Waivers and Liability Insurance',
    ],
  },
]

export interface Bonus {
  emoji: string
  title: string
  format: string
  body: string
  image?: string
}

export const BONUSES: Bonus[] = [
  {
    emoji: '🏓',
    title: 'Class Generator',
    format: 'Excel',
    body: 'An 49-drill Drill Bank plus a live Generator sheet. Set Level, Duration, and Focus of the day, and the spreadsheet builds the full class — warm-up, technique, game, cooldown — automatically, with total duration calculated.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/81349ebb-71cf-4a25-a507-a4b970c7bb12.jpg',
  },
  {
    emoji: '🧮',
    title: 'Pricing Calculator',
    format: 'Excel',
    body: 'Three linked sheets: enter your real costs once, get a suggested rate per class type (private/semi-private/group/clinic) that respects your minimum margin, then simulate monthly income against your actual student roster and income goal.',
  },
  {
    emoji: '📇',
    title: 'Student CRM',
    format: 'Excel',
    body: "A live Dashboard fed by Students and Payments sheets. Automatic color-coded status (Active / Needs Follow-up / At Risk of Churning) flags students who haven't shown up in over two weeks.",
  },
  {
    emoji: '⚖️',
    title: 'Legal Kit',
    format: 'Word',
    body: 'Three ready-to-use templates: Liability Waiver, Teaching Services Agreement, and Cancellation Policy — with a clear disclaimer to have them reviewed by a licensed attorney in your state.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/2b914951-7e99-4f35-9582-7f61ebee96a6.jpg',
  },
  {
    emoji: '💌',
    title: 'Message Kit',
    format: 'Word',
    body: '25+ ready-to-send WhatsApp/Email/SMS messages covering every touchpoint: first contact, confirmations, reminders, no-shows, follow-ups, renewals, reactivation, review requests, and more.',
  },
  {
    emoji: '📚',
    title: 'Pre-Built Class Library',
    format: 'Word',
    body: '40 fully mapped-out classes — 10 Absolute Beginner, 10 Level 3.0, 10 Level 3.5–4.0, 5 Senior/Limited Mobility, 5 Junior — plus 4 event-style 90-minute clinics, a 4-week and an 8-week ready-to-sell bootcamp program, a blank editable class template, and a suggested annual programming calendar. Built entirely from the same Drill Bank used in Bonus 1.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ad5fda64-6de7-42ce-a9cf-ad39a366c887.jpg',
  },
]

export const PAIN_POINTS: string[] = [
  "You keep lowering your rates because you're afraid students will leave if you charge what you're actually worth.",
  'You improvise your classes on the fly and end up teaching the same drills over and over with no clear progression.',
  'Students take a few lessons, feel good, and then quietly disappear — and you never know why they stopped coming.',
  "You're a great player but you struggle to explain the third shot drop or a strategy in a way beginners actually get.",
  "You have no system to track payments, packages, or who's due for a renewal — so income feels random every month.",
]

export interface Review {
  name: string
  city: string
  text: string
}

export const REVIEWS: Review[] = [
  {
    name: 'Mike Sullivan',
    city: 'Naples, FL',
    text: "I've been coaching pickleball for 3 years and this is the first resource that actually treats it like a real business. The pricing calculator alone paid for itself in one week.",
  },
  {
    name: 'Debbie Harmon',
    city: 'Scottsdale, AZ',
    text: 'The pre-built classes are a lifesaver. I coach a lot of 55+ players and the senior routines are gold. I stopped improvising and my students noticed the difference immediately.',
  },
  {
    name: 'Carlos Mendez',
    city: 'Austin, TX',
    text: "Went from 12 to 30 weekly students in two months using the referral system and the message templates. Wish I'd had this when I started.",
  },
  {
    name: 'Karen Whitfield',
    city: 'Charlotte, NC',
    text: "The CRM finally gave me control over my roster. I can see who's about to churn and reach out before I lose them. Absolute game changer for retention.",
  },
]

export interface Testimonial {
  name: string
  age: number
  city: string
  text: string
}

export const TESTIMONIALS: Testimonial[] = [
  {
    name: 'Greg Patterson',
    age: 52,
    city: 'Tampa, FL',
    text: "Best $25 I've spent on my coaching career. Everything is done-for-you.",
  },
  {
    name: 'Linda Cortez',
    age: 47,
    city: 'Phoenix, AZ',
    text: 'I raised my rates 40% and nobody blinked. The value framing scripts work.',
  },
  {
    name: 'Tom Whitaker',
    age: 58,
    city: 'Denver, CO',
    text: 'Delivered instantly, opened it on my phone at the court. Super practical.',
  },
  {
    name: 'Sandra Klein',
    age: 44,
    city: 'San Diego, CA',
    text: 'The Excel tools are ridiculously good. My monthly income is finally predictable.',
  },
  {
    name: 'Rick Donovan',
    age: 55,
    city: 'Columbus, OH',
    text: 'Went full-time thanks to the business volume. Clear, no fluff, all action.',
  },
]

export interface Objection {
  q: string
  a: string
}

export const OBJECTIONS: Objection[] = [
  {
    q: "I'm just starting out — is this too advanced for me?",
    a: 'Not at all. The kit starts from the absolute fundamentals and gives you ready-to-run beginner classes, so you can teach with confidence from day one, even without years of experience.',
  },
  {
    q: 'Is it really 100% digital? When do I get it?',
    a: "Yes — it's fully digital (PDF + editable Excel/Word files) and delivered instantly to your email right after purchase. No shipping, no waiting.",
  },
  {
    q: '$25 seems too cheap. Is it actually complete?',
    a: "It's 7 full modules plus 6 practical bonus tools. The $25 launch price is an intro offer to get it into as many coaches' hands as possible — the regular price is $75.",
  },
  {
    q: "I'm not tech-savvy. Can I use the Excel and Word tools?",
    a: 'Absolutely. Everything is pre-built — you just fill in a few cells or edit text. If you can open a spreadsheet or a document, you can use every tool in the kit.',
  },
  {
    q: "What if it's not for me?",
    a: 'Reach out any time at EbookDreamShop@gmail.com and our support team will personally help you get the most out of the kit.',
  },
]

export const BUYER_NAMES = [
  'James',
  'Robert',
  'Michael',
  'David',
  'William',
  'Patricia',
  'Jennifer',
  'Linda',
  'Barbara',
  'Susan',
  'Karen',
  'Nancy',
  'Greg',
  'Tom',
  'Rick',
  'Sandra',
  'Debbie',
  'Mike',
  'Carlos',
  'Karen',
]

export const BUYER_CITIES = [
  'Tampa, FL',
  'Phoenix, AZ',
  'Denver, CO',
  'San Diego, CA',
  'Columbus, OH',
  'Austin, TX',
  'Naples, FL',
  'Scottsdale, AZ',
  'Charlotte, NC',
  'Dallas, TX',
  'Seattle, WA',
  'Portland, OR',
  'Nashville, TN',
  'Atlanta, GA',
  'Boston, MA',
  'Sacramento, CA',
  'Orlando, FL',
  'Las Vegas, NV',
  'Raleigh, NC',
  'Kansas City, MO',
]
